document.addEventListener('DOMContentLoaded', function() {
    const sliderContainer = document.querySelector('.hero-slider-container');
    if (!sliderContainer) {
        return;
    }

    const slides = sliderContainer.querySelectorAll('.hero-slide');
    const dotsContainer = sliderContainer.querySelector('.slider-dots');
    const dots = sliderContainer.querySelectorAll('.dot');
    const slideInterval = 5000;
    let currentIndex = 0;
    let autoSlideTimer;

    function adjustSliderHeight(index) {
        const image = sliderContainer.querySelector(`.hero-slide-image[data-slide-index="${index}"]`);
        const overlay = sliderContainer.querySelector(`.hero-slide[data-slide-index="${index}"] .hero-slide-overlay`);

        if (image) {
            const imageAspectRatio = image.naturalHeight / image.naturalWidth;
            const heightFromImage = sliderContainer.clientWidth * imageAspectRatio;

            overlay.style.visibility = 'hidden';
            overlay.style.animation = 'none';
            overlay.style.opacity = '1';
            const heightFromOverlayContent = overlay.offsetHeight;
            overlay.style.visibility = '';
            overlay.style.animation = '';
            overlay.style.opacity = '';

            const newHeight = Math.max(heightFromImage, heightFromOverlayContent);

            sliderContainer.style.height = `${newHeight}px`;
        }
    }

    function placeDotsInActiveSlide(index) {
        const targetSlide = sliderContainer.querySelector(`.hero-slide[data-slide-index="${index}"]`);
        const contentContainer = targetSlide.querySelector('.hero-slide-content');

        if (contentContainer && dotsContainer) {
            contentContainer.appendChild(dotsContainer);
            dotsContainer.style.display = 'flex';
        }
    }

    function goToSlide(index) {
        if (index === currentIndex && slides.length > 1) return;

        slides[currentIndex].classList.remove('active');
        currentIndex = index;
        slides[currentIndex].classList.add('active');

        dots.forEach((dot, dotIndex) => {
            dot.classList.toggle('active', dotIndex === currentIndex);
        });

        placeDotsInActiveSlide(currentIndex);

        const image = sliderContainer.querySelector(`.hero-slide-image[data-slide-index="${index}"]`);
        if (image.complete) {
            adjustSliderHeight(currentIndex);
        } else {
            image.addEventListener('load', () => adjustSliderHeight(currentIndex), { once: true });
        }
    }

    function nextSlide() {
        const nextIndex = (currentIndex + 1) % slides.length;
        goToSlide(nextIndex);
    }

    function startAutoSlide() {
        stopAutoSlide();
        autoSlideTimer = setInterval(nextSlide, slideInterval);
    }

    function stopAutoSlide() {
        clearInterval(autoSlideTimer);
    }

    function initSlider() {
        if (slides.length === 0) {
            return;
        }

        placeDotsInActiveSlide(0);

        const firstImage = sliderContainer.querySelector('.hero-slide-image[data-slide-index="0"]');

        // This function will fade in the slider once the first image is ready
        const revealSlider = () => {
            sliderContainer.classList.add('is-ready');
            // We still run adjustSliderHeight to ensure the content fits perfectly,
            // even if the aspect ratio from PHP was already close.
            adjustSliderHeight(0);
        };

        if (firstImage.complete) {
            revealSlider();
        } else {
            firstImage.addEventListener('load', revealSlider, { once: true });
        }

        window.addEventListener('resize', () => {
            // We don't need to re-reveal, just adjust height
            adjustSliderHeight(currentIndex);
        });

        dots.forEach(dot => {
            dot.addEventListener('click', function() {
                const slideIndex = parseInt(this.getAttribute('data-slide'));
                goToSlide(slideIndex);
                startAutoSlide();
            });
        });

        if (slides.length > 1) {
            startAutoSlide();
            sliderContainer.addEventListener('mouseenter', stopAutoSlide);
            sliderContainer.addEventListener('mouseleave', startAutoSlide);
        }
    }

    // Run the initialization
    initSlider();
});